import type { FieldPack } from '../../../../core/fields/types';
import { FieldType } from '../../../../core/fields/types';

export const networkTagsFieldPack: FieldPack = {
  id: 'network-tags',
  name: 'Tags & Ownership',
  description: 'AWS tags driving perspectives (ownership, environment, cost center)',
  version: '1.0.0',
  dependencies: ['network-base'],
  fields: [
    {
      id: 'tags',
      label: 'Tags',
      type: FieldType.COMPOSITE,
      tags: ['metadata'],
      priority: 60,
      sensitivity: 'public',
    },
    {
      id: 'env',
      label: 'Environment',
      type: FieldType.SELECT,
      tags: ['metadata', 'environment'],
      priority: 55,
      options: [
        { value: 'prod', label: 'Production' },
        { value: 'staging', label: 'Staging' },
        { value: 'dev', label: 'Development' },
        { value: 'test', label: 'Test' },
      ],
      sensitivity: 'public',
    },
    {
      id: 'team',
      label: 'Team',
      type: FieldType.TEXT,
      tags: ['metadata', 'ownership'],
      priority: 50,
      sensitivity: 'public',
    },
    {
      id: 'owner',
      label: 'Owner',
      type: FieldType.TEXT,
      tags: ['metadata', 'ownership'],
      priority: 45,
      sensitivity: 'public',
    },
    {
      id: 'costCenter',
      label: 'Cost Center',
      type: FieldType.TEXT,
      tags: ['metadata', 'cost'],
      priority: 40,
      sensitivity: 'internal',
    },
  ],
};
